import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchDestinationTags } from 'actions/PlaceActions'

interface UseDestinationTagsResult {
  tags: Array<{ id: string; name: string }>
  fetching: boolean
}

interface Options {
  disabled?: boolean
}

/**
 * Hook to fetch and access destination tags from Redux store
 * @param destinationId - The destination ID to fetch tags for
 * @param options - Optional configuration including disabled flag
 * @returns Object containing tags array and fetching status
 */
function useDestinationTags(
  destinationId: string | undefined,
  options: Options = {},
): UseDestinationTagsResult {
  const dispatch = useAppDispatch()

  const tagData = useAppSelector(state => {
    if (!destinationId || options.disabled) {
      return undefined
    }
    return state.destination.destinationTags[destinationId]
  })

  useEffect(() => {
    if (!destinationId || options.disabled) {
      return
    }

    dispatch(fetchDestinationTags(destinationId))
  }, [dispatch, destinationId, options.disabled])

  return {
    tags: tagData?.tags ?? [],
    fetching: tagData?.fetching ?? false,
  }
}

export default useDestinationTags
